module.exports = __webpack_public_path__ + "img/slide-uz.d36f6a18.png";